import PaymentProofForm from './PaymentProofForm';

export default PaymentProofForm;
